import React from 'react';

type Props = {
  label: React.ReactNode;
  onClick: () => void;
  style: React.CSSProperties;
};
const LinkAction: React.FC<Props> = (props) => {
  const { style, label, onClick } = props;
  return (
    <span
      style={style}
      onClick={onClick}
      role="button"
      onKeyPress={onClick}
      tabIndex={0}
    >
      {label}
    </span>
  );
};

export default LinkAction;
